import Store from '../stores/store';

export enum ReceivingEvent {
    ChannelOrTransactionChanged = 'channelOrTransactionChanged',
}

const isReceivingEvent = (value: string): value is ReceivingEvent => {
    return Object.values(ReceivingEvent).indexOf(value as any) !== -1;
};

interface ReceivePayload {
    [ReceivingEvent.ChannelOrTransactionChanged]: {channel: string};
}

type EventCallback<E extends ReceivingEvent> = (value: ReceivePayload[E]) => void;

class GwtCommunication {
    private listeners: {[key in ReceivingEvent]: Array<EventCallback<key>>} = {
        [ReceivingEvent.ChannelOrTransactionChanged]: [],
    };

    public startListen = () => {
        window.addEventListener('message', (event) => {
            if (typeof event.data !== 'object') {
                console.log('Cannot handle ', event);
                return;
            }

            const type = event.data.type;
            if (!isReceivingEvent(type)) {
                console.log('Unknown event ', event.data);
                return;
            }
            this.listeners[type].forEach((listener: EventCallback<any>) => listener(event.data));
        });
    };

    public on = <E extends ReceivingEvent>(type: E, callback: EventCallback<E>) => {
        this.listeners[type] = [...(this.listeners[type] as Array<EventCallback<E>>), callback];
    };
}

export const bootGwtCommunication = (store: Store): GwtCommunication => {
    const gwtCommunication = new GwtCommunication();
    gwtCommunication.on(ReceivingEvent.ChannelOrTransactionChanged, (channelPackage) => {
        const {channelStore} = store;
        const channel = channelPackage.channel;
        const channelIsDifferent =
            channelStore.selectedChannel === undefined || (channelStore.selectedChannel && channelStore.selectedChannel.name !== channel);
        if (channelIsDifferent) {
            channelStore.setSelectedChannel(channel);
        }
    });
    return gwtCommunication;
};



// WEBPACK FOOTER //
// ./src/boot/GwtCommunications.ts